const OrdersLineLoader = () => {
  return <div className={"skeletonBlock"} style={{ height: "50vh", borderRadius: "16px" }} />
}

export default OrdersLineLoader
